<template>

<div>

  <div class="main-content container-fluid">
    <div class="row">
      <!-- <PageHeader title="My Lecture Notes" /> -->
      <div class="col-md-12">

        <Panel class="panel panel-default panel-border-color panel-border-color-primary">
          <PanelHeading title="Lecture Notes" subtitle="Lecture Notes can be converted to Micro Notes for studying"></PanelHeading>
          <PanelBody>

            <code>#todo list them with links to editor to edit content</code>

            <h3>Lecture notes</h3>
            {{lectureNotes}}

          </PanelBody>
        </Panel>

      </div><!-- /.col -->
    </div><!-- /.row -->
  </div><!-- /.main-content -->
</div>





</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
  },


  created() {
    // Fetch Lecture Notes
    // this.getLectureNotes();
  },
  //{"email": "bob@example.com", "password": "password", "password\_confirmation": "password"}
  methods: {
    ...mapActions({
      // getLectureNotes: 'getLectureNotes',
    })
  },

  computed: {
    ...mapState({
      lectureNotes: (state) => {
        return state.lectureNotes.all;
      }
    }),
  },


  data() {
    return {}
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// LectureNoteList.vue?57fa8cb5